import Heading from "../components/common/Heading";
import TextBox from "../components/TextBox";
import Teaser from "../components/Teaser";
import PricingBox from "../components/PricingBox";
import AddOns from "../components/AddOns";
import BoxedTextBox from "../components/BoxedTextBox";

function ParseBoxTypes(props) {
   let el = props.el,
       box_type = el.box_type,
       parent = (box_type != 'membership_prices') ? el[el.box_type]: false,
       lang = props.lang,
       box = (box_type != 'membership_prices') ? el[el.box_type][lang]: false;

   if(box_type === 'headline'){
      return (<Heading title={box.title} subtitle={box.text} className="tw-pt-2 sm:tw--mb-2 lg:tw-mb-4" />)
   }
   else if (box_type == 'text_box'){
      return (<TextBox title={box.title} text={box.text} lang={lang} button={box.button} className="tw-pt-2 sm:tw--mb-4 lg:tw-mb-0" fullBackground={parent.full_background_color} textcolor={parent.font_color} backgroundColor={parent.background_color} />)
   }
   else if (box_type == 'boxed_element'){
      console.log('boxed_element', box);
      return (<BoxedTextBox title={box.title} text={box.text} lang={lang} button={box.button} className="tw-pt-2 sm:tw--mb-4 lg:tw-mb-0" fullBackground={parent.full_background_color} backgroundColor={parent.background_color} />)
   }
   else if (box_type == 'text_image'){
      return (<Teaser title={box.title} text={box.text} lang={lang} defaultImage={parent['de'].img} image={box.img} colordot={parent.color_dot} position={parent.position} button={box.button} className="tw-pt-2 sm:tw--mb-4 lg:tw-mb-0" />)
   }
   else if (box_type == 'membership_prices'){
      return (<PricingBox items={props.prices} lang={lang}/>)
   }
   else if (box_type == 'addons'){
      return Array.isArray(parent.addons) ? (<AddOns prices={props.prices} items={parent.addons} size="large" lang={lang}/>) : <p>Loading...</p>;
   }
   else{
      return (<h1>{el.box_type}</h1>);
   }
}
export default ParseBoxTypes;